import { isHoliday } from 'feiertagejs';

const FEDERAL_STATES = ['BW', 'BY', 'BE', 'BB', 'HB', 'HE', 'HH', 'MV', 'NI', 'NW', 'RP', 'SL', 'SN', 'ST', 'SH', 'TH'] as const;
type FederalState = (typeof FEDERAL_STATES)[number];

// feiertagejs throws on unknown regions, so anything unexpected falls back to nationwide holidays.
const isKnownFederalState = (value: string | null | undefined): value is FederalState =>
    !!value && (FEDERAL_STATES as readonly string[]).includes(value);

/** Noon UTC falls on the same calendar day in Germany, which is what feiertagejs compares against. */
const toGermanDayAnchor = (dayStr: string) => new Date(`${dayStr}T12:00:00Z`);

/** Expects `yyyy-MM-dd`. */
export const isSundayDate = (dayStr: string) => toGermanDayAnchor(dayStr).getUTCDay() === 0;

export const isHolidayForStore = (dayStr: string, federalState: string | null | undefined) => {
    const region = isKnownFederalState(federalState) ? federalState : 'BUND';
    return isHoliday(toGermanDayAnchor(dayStr), region);
};

/** Sundays and holidays stay open when practitioners still have bookable slots that day. */
export const isStoreClosedOnDate = (dayStr: string, federalState: string | null | undefined, hasAvailability = false) =>
    !hasAvailability && (isSundayDate(dayStr) || isHolidayForStore(dayStr, federalState));
